export const sliderContainer = "homeCss_sliderContainer";
export const sliderWidthFixer = "homeCss_sliderWidthFixer";
export const sliderClipRectAnimation = "homeCss_sliderClipRectAnimation";
export const sliderClipRect = "homeCss_sliderClipRect";
export const sliderInner = "homeCss_sliderInner";
export const sliderImgContainer = "homeCss_sliderImgContainer";
export const sliderSlideContainerAnimation = "homeCss_sliderSlideContainerAnimation";
export const sliderSlideContainer = "homeCss_sliderSlideContainer";
export const sliderBar = "homeCss_sliderBar";
export const sliderHandle = "homeCss_sliderHandle";
export const sliderHandleIcon = "homeCss_sliderHandleIcon";
export const sliderImg = "homeCss_sliderImg";
export const stepsContainerBg = "homeCss_stepsContainerBg";
export const socialContainerBg = "homeCss_socialContainerBg";
export const socialContainerBgOverlay = "homeCss_socialContainerBgOverlay";
export const socialHeader = "homeCss_socialHeader";
export const socialCotnent = "homeCss_socialCotnent";
export const socialBtn = "homeCss_socialBtn";
export const socialBtnIcon = "homeCss_socialBtnIcon";
export const socialBtnContainer = "homeCss_socialBtnContainer";
export const stepsBgIcon = "homeCss_stepsBgIcon";
export const stepsContainer = "homeCss_stepsContainer";
export const stepsLeft = "homeCss_stepsLeft";
export const stepsIcon = "homeCss_stepsIcon";
export const stepsTitle = "homeCss_stepsTitle";
export const stepsRight = "homeCss_stepsRight";
export const stepsImgTile = "homeCss_stepsImgTile";
export const stepsImgTileAnimation = "homeCss_stepsImgTileAnimation";
export const stepsImgTileContainer = "homeCss_stepsImgTileContainer";
export const stepsImgTileColumn = "homeCss_stepsImgTileColumn";
export const customersContainerBG = "homeCss_customersContainerBG";
export const customersContainer = "homeCss_customersContainer";
export const description = "homeCss_description";
export const subcontracted = "homeCss_subcontracted";
export const customersIconsContainer = "homeCss_customersIconsContainer";
export const customersIcon = "homeCss_customersIcon";
export const customersIconSmall = "homeCss_customersIconSmall";
export const customersIconXXLarge = "homeCss_customersIconXXLarge";
export const customersIconXLarge = "homeCss_customersIconXLarge";
export const customersIconLarge = "homeCss_customersIconLarge";
export const thumbsUp = "homeCss_thumbsUp";
export const heroFullContainer = "homeCss_heroFullContainer";
export const heroBgContainer = "homeCss_heroBgContainer";
export const heroAspectContainer = "homeCss_heroAspectContainer";
export const heroBgImg = "homeCss_heroBgImg";
export const heroIframe = "homeCss_heroIframe";
export const heroAspectSizer = "homeCss_heroAspectSizer";
export const heroBotGradient = "homeCss_heroBotGradient";
export const heroContentContainer = "homeCss_heroContentContainer";
export const heroH1 = "homeCss_heroH1";
export const heroH1Span = "homeCss_heroH1Span";
export const heroH1SpanSpace = "homeCss_heroH1SpanSpace";
export const heroAquariumTextContainer = "homeCss_heroAquariumTextContainer";
export const heroAquariumText = "homeCss_heroAquariumText";
export const heroPondText = "homeCss_heroPondText";
export const heroImg = "homeCss_heroImg";
export const heroFgContainer = "homeCss_heroFgContainer";
export const videoContainer = "homeCss_videoContainer";
export const heroImgTest = "homeCss_heroImgTest";
export const iframeVideoContainer = "homeCss_iframeVideoContainer";
export const heroSlashContainer = "homeCss_heroSlashContainer";
export const logoIcon = "homeCss_logoIcon";
export const heroH1Icon = "homeCss_heroH1Icon";
export const heroFishIcon = "homeCss_heroFishIcon";
export const heroH2Container = "homeCss_heroH2Container";
export const heroH2 = "homeCss_heroH2";
export const ctaContainer = "homeCss_ctaContainer";
export const ctaBtn = "homeCss_ctaBtn";
export const logoText = "homeCss_logoText";
export const fixedBgContainer = "homeCss_fixedBgContainer";
export const fixedBgImg = "homeCss_fixedBgImg";
export const midSectionContainer = "homeCss_midSectionContainer";
export const underwaterBgContainer = "homeCss_underwaterBgContainer";
export const underwaterBgImg = "homeCss_underwaterBgImg";
export const displayContainerBg = "homeCss_displayContainerBg";
export const displayContainer = "homeCss_displayContainer";
export const displayBox = "homeCss_displayBox";
export const displayBoxTop2 = "homeCss_displayBoxTop2";
export const displayBoxIcon = "homeCss_displayBoxIcon";
export const displayBoxTitle = "homeCss_displayBoxTitle";
export const displayBoxsContainer = "homeCss_displayBoxsContainer";
export const grassContainer = "homeCss_grassContainer";
export const grassIcon = "homeCss_grassIcon";
export const displayOtherContainer = "homeCss_displayOtherContainer";
export const displayOtherContainerSection = "homeCss_displayOtherContainerSection";
export const displayDetailContaienr = "homeCss_displayDetailContaienr";
export const displayCheckMarkContainer = "homeCss_displayCheckMarkContainer";
export const displayCheckMark = "homeCss_displayCheckMark";
export const largeTitleThin = "homeCss_largeTitleThin";
export const numbersContainer = "homeCss_numbersContainer";
export const numbersRow = "homeCss_numbersRow";
export const numbersBox = "homeCss_numbersBox";
export const numbersNumber = "homeCss_numbersNumber";
export const numbersTitle = "homeCss_numbersTitle";
export const numbersSubTitle = "homeCss_numbersSubTitle";
export const numbersDesc = "homeCss_numbersDesc";
export const numbersPlant = "homeCss_numbersPlant";
export const numbersPlantTest = "homeCss_numbersPlantTest";
export const numbersPlant2 = "homeCss_numbersPlant2";
export const numbersMainDesc = "homeCss_numbersMainDesc";
export const transformContainerBG = "homeCss_transformContainerBG";
export const transformContainer = "homeCss_transformContainer";
export const transformAfterImage = "homeCss_transformAfterImage";
export const transformImage = "homeCss_transformImage";
export const transformRight = "homeCss_transformRight";
export const transformRightIcon = "homeCss_transformRightIcon";
export const transformRightTitle = "homeCss_transformRightTitle";
